import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { boostersFontCss, premiumFontCss } from '@blade/ui-theme'

import type { ButtonProps } from '@blade/ui-kit'

type ButtonPurchaseProps = {
  product: 'premium' | 'boosters'
} & Omit<ButtonProps, 'color'>

export const ButtonPurchase: React.FC<ButtonPurchaseProps> = ({
  product,
  children,
  ...props
}) => {
  return (
    <ButtonAlt variant="secondary" data-product={product} {...props}>
      <span>{children}</span>
    </ButtonAlt>
  )
}

const ButtonAlt = styled(Button)`
  position: relative;
  isolation: isolate;

  &:not(:disabled) {
    border: none;

    &[data-product='premium'] {
      > span {
        ${premiumFontCss}
        transition: filter 0.2s ease;
      }

      &:after {
        transition: background 0.2s ease;
      }

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        padding: 1px;
        background: linear-gradient(
          90deg,
          color-mix(in srgb, var(--subscriptionGradientFrom-9) 50%, transparent)
            1.52%,
          color-mix(in srgb, var(--subscriptionGradientTo-9) 50%, transparent)
            122.56%
        );
        -webkit-mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
        pointer-events: none;
        z-index: -2;
      }

      &:after {
        content: '';
        position: absolute;
        inset: 1px;
        border-radius: inherit;
        background: var(--subscriptionGlowA-3);
        pointer-events: none;
        z-index: -1;
      }

      &:hover:not(:disabled) {
        > span {
          filter: brightness(1.1);
        }

        &:after {
          background: var(--subscriptionGlowA-5);
        }
      }
    }
    &[data-product='boosters'] {
      > span {
        ${boostersFontCss}
        transition: filter 0.2s ease;
      }

      &:after {
        transition: background 0.2s ease;
      }

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        padding: 1px;
        background: linear-gradient(
          111deg,
          color-mix(in srgb, var(--boostGradientFrom-9) 50%, transparent) 17.4%,
          color-mix(in srgb, var(--boostGradientTo-9) 50%, transparent) 117.02%
        );
        -webkit-mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        mask-composite: exclude;
        pointer-events: none;
        z-index: -2;
      }

      &:after {
        content: '';
        position: absolute;
        inset: 1px;
        border-radius: inherit;
        background: var(--boostGlowA-3);
        pointer-events: none;
        z-index: -1;
      }

      &:hover:not(:disabled) {
        > span {
          filter: brightness(1.1);
        }

        &:after {
          background: var(--boostGlowA-5);
        }
      }
    }
  }

  &:disabled {
    background: transparent;
    border: 1px solid var(--background-4);
  }
`
